import {
  GET_RELIGION,
  GET_RELIGION_SUCCESS,
  GET_RELIGION_FAIL,
  DELETE_RELIGION,
  DELETE_RELIGION_SUCCESS,
  DELETE_RELIGION_FAIL,
  UPDATE_RELIGION,
  UPDATE_RELIGION_SUCCESS,
  UPDATE_RELIGION_FAIL,
  ADD_NEW_RELIGION,
  ADD_RELIGION_SUCCESS,
  ADD_RELIGION_FAIL,
  RELIGION_LOADING,
} from "./actionType";

export const getReligionSuccess = (actionType, data) => ({
  type: GET_RELIGION_SUCCESS,
  payload: { actionType, data },
});

export const getReligionFail = (actionType, error) => ({
  type: GET_RELIGION_FAIL,
  payload: { actionType, error },
});

export const getReligion = data => ({
  type: GET_RELIGION,
  payload: data,
});

export const getReligionLoading = () => ({
  type: RELIGION_LOADING
});

export const deleteReligion = data => ({
  type: DELETE_RELIGION,
  payload: data,
});

export const deleteReligionSuccess = data => ({
  type: DELETE_RELIGION_SUCCESS,
  payload: data,
});

export const deleteReligionFail = error => ({
  type: DELETE_RELIGION_FAIL,
  payload: error,
});

export const updateReligion = data => ({
  type: UPDATE_RELIGION,
  payload: data,
});

export const updateReligionFail = error => ({
  type: UPDATE_RELIGION_FAIL,
  payload: error,
});

export const updateReligionSuccess = data => ({
  type: UPDATE_RELIGION_SUCCESS,
  payload: data,
});

export const addNewReligion = data => ({
  type: ADD_NEW_RELIGION,
  payload: data,
});

export const addReligionSuccess = data => ({
  type: ADD_RELIGION_SUCCESS,
  payload: data,
});

export const addReligionFail = error => ({
  type: ADD_RELIGION_FAIL,
  payload: error,
});